import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OperationDetailsEditPage } from './operation-details-edit';
import { SharedModule } from '../../shared/shared.module';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { TextMaskModule } from 'angular2-text-mask';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OperationDetailsEditPage,
  ],
  imports: [
    IonicPageModule.forChild(OperationDetailsEditPage),
    SharedModule,
    FoundationModule,
    TextMaskModule,
    DirectivesModule,
  ],
  providers: []
})
export class OperationDetailsEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-details-edit/operation-details-edit.module.ts